import React from "react";
import { FormGroup, Label, Input } from "reactstrap";
import { formOptions } from "./constants";

const PropertyInfo = ({ formData, handleChange, errors }) => {
  return (
    <>
      <FormGroup>
        <Label for="statusKepemilikanRumah">18. Status Kepemilikan Rumah</Label>
        <Input 
          type="select" 
          name="statusKepemilikanRumah" 
          id="statusKepemilikanRumah" 
          value={formData.statusKepemilikanRumah} 
          onChange={handleChange}
          disabled={formData.statusrumah === "Tidak Berpenghuni"}
          className={errors.statusKepemilikanRumah ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.statusKepemilikanRumah.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.statusKepemilikanRumah && <div className="invalid-feedback">{errors.statusKepemilikanRumah}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="asetRumahDiTempatLain">19. Aset Rumah di Tempat lain</Label>
        <Input 
          type="select" 
          name="asetRumahDiTempatLain" 
          id="asetRumahDiTempatLain" 
          value={formData.asetRumahDiTempatLain} 
          onChange={handleChange}
          disabled={formData.statusrumah === "Tidak Berpenghuni"}
          className={errors.asetRumahDiTempatLain ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.asetRumahDiTempatLain.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.asetRumahDiTempatLain && <div className="invalid-feedback">{errors.asetRumahDiTempatLain}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="statusKepemilikanTanah">20. Status Kepemilikan Tanah</Label>
        <Input 
          type="select" 
          name="statusKepemilikanTanah" 
          id="statusKepemilikanTanah" 
          value={formData.statusKepemilikanTanah} 
          onChange={handleChange}
          disabled={formData.statusrumah === "Tidak Berpenghuni"}
          className={errors.statusKepemilikanTanah ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.statusKepemilikanTanah.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.statusKepemilikanTanah && <div className="invalid-feedback">{errors.statusKepemilikanTanah}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="asetTanahDiTempatLain">21. Aset Tanah di Tempat Lain</Label>
        <Input 
          type="select" 
          name="asetTanahDiTempatLain" 
          id="asetTanahDiTempatLain" 
          value={formData.asetTanahDiTempatLain} 
          onChange={handleChange}
          disabled={formData.statusrumah === "Tidak Berpenghuni"}
          className={errors.asetTanahDiTempatLain ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.asetTanahDiTempatLain.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.asetTanahDiTempatLain && <div className="invalid-feedback">{errors.asetTanahDiTempatLain}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="sumberPenerangan">22. Sumber Penerangan</Label>
        <Input 
          type="select" 
          name="sumberPenerangan" 
          id="sumberPenerangan" 
          value={formData.sumberPenerangan} 
          onChange={handleChange}
          disabled={formData.statusrumah === "Tidak Berpenghuni"}
          className={errors.sumberPenerangan ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.sumberPenerangan.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.sumberPenerangan && <div className="invalid-feedback">{errors.sumberPenerangan}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="dayaListrik">23. Daya Listrik</Label>
        <Input 
          type="select" 
          name="dayaListrik" 
          id="dayaListrik" 
          value={formData.dayaListrik} 
          onChange={handleChange}
          disabled={formData.statusrumah === "Tidak Berpenghuni"}
          className={errors.dayaListrik ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.dayaListrik.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.dayaListrik && <div className="invalid-feedback">{errors.dayaListrik}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="bantuanPerumahan">24. Bantuan Perumahan</Label>
        <Input 
          type="select" 
          name="bantuanPerumahan" 
          id="bantuanPerumahan" 
          value={formData.bantuanPerumahan} 
          onChange={handleChange}
          disabled={formData.statusrumah === "Tidak Berpenghuni"}
          className={errors.bantuanPerumahan ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.bantuanPerumahan.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.bantuanPerumahan && <div className="invalid-feedback">{errors.bantuanPerumahan}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="modelRumah">25. Jenis Rumah</Label>
        <Input 
          type="select" 
          name="modelRumah" 
          id="modelRumah" 
          value={formData.modelRumah} 
          onChange={handleChange}
          className={errors.modelRumah ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.modelRumah.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.modelRumah && <div className="invalid-feedback">{errors.modelRumah}</div>}
      </FormGroup>
    </>
  );
};

export default PropertyInfo;
